import { ISupplierAddRequest } from '../../../../model/sge/supplier/request/supplier-add-edit-request';
import { ISupplierResponse } from '../../../../model/sge/supplier/response/supplier-response';
import { IZipCodeResponse } from '../../../../model/base/location-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export type SupplierField = 'name' | 'document' | 'zipCode' | 'countryId' | 'stateId' | 'municipalityId' | 'street' | 'number' | 'neighborhood';

export function isPhysicalPerson(form: ISupplierAddRequest): boolean {
    return (form.supplierPersonType || 'PF') === 'PF';
}

export function toSupplierForm(data?: ISupplierResponse): ISupplierAddRequest {
    if (!data) return { supplierPersonType: 'PF', address: {}, contact: {} };
    return {
        name: data.personName,
        supplierPersonType: data.supplierPersonType,
        physicalPerson: data.cpf ? { cpf: data.cpf } : undefined,
        legalPerson: data.cnpj ? { cnpj: data.cnpj } : undefined,
        address: {
            countryId: data.countryId,
            stateId: data.stateId,
            municipalityId: data.municipalityId,
            street: data.addressStreet,
            number: data.addressNumber,
            neighborhood: data.addressNeighborhood,
            zipCode: data.addressZipCode,
            complement: data.addressComplement,
        },
        contact: {
            email: data.contactEmail,
            phone: data.contactPhone,
            mobile: data.contactMobile,
        },
    };
}

export function validateSupplier(form: ISupplierAddRequest): ValidationErrors<SupplierField> {
    const errors: ValidationErrors<SupplierField> = {};
    const address = form.address || {};
    const isPF = isPhysicalPerson(form);
    if (isBlank(form.name)) errors.name = isPF ? 'Nome é obrigatório' : 'Razão social é obrigatória';
    if (isPF && isBlank(form.physicalPerson?.cpf)) errors.document = 'CPF é obrigatório';
    if (!isPF && isBlank(form.legalPerson?.cnpj)) errors.document = 'CNPJ é obrigatório';
    if (isBlank(address.zipCode)) errors.zipCode = 'CEP é obrigatório';
    if (isEmptyId(address.countryId)) errors.countryId = 'País é obrigatório';
    if (isEmptyId(address.stateId)) errors.stateId = 'Estado é obrigatório';
    if (isEmptyId(address.municipalityId)) errors.municipalityId = 'Município é obrigatório';
    if (isBlank(address.street)) errors.street = 'Logradouro é obrigatório';
    if (isBlank(address.number)) errors.number = 'Número é obrigatório';
    if (isBlank(address.neighborhood)) errors.neighborhood = 'Bairro é obrigatório';
    return errors;
}

// CEP com 8 dígitos (com ou sem máscara) ou undefined quando incompleto
export function normalizeZipCode(value?: string): string | undefined {
    const digits = (value || '').replace(/\D/g, '');
    return digits.length === 8 ? digits : undefined;
}

// Endereço preenchido a partir do CEP; undefined quando a consulta não retornou localidade
export function addressFromZipCode(data: IZipCodeResponse): ISupplierAddRequest['address'] | undefined {
    if (!data.countryId && !data.stateId && !data.cityId) return undefined;
    return {
        countryId: data.countryId ?? undefined,
        stateId: data.stateId ?? undefined,
        municipalityId: data.cityId ?? undefined,
        street: data.street ?? undefined,
        neighborhood: data.neighborhood ?? undefined,
        complement: data.complement ?? undefined,
    };
}
